// Copyright 2020 Sorama B.V.

import { IWorkflowTourLink } from "libraries/WorkflowFramework/Interfaces/IWorkflowTour";
export class WorkflowTourCatalog {
    static MeasurementBasicTour: IWorkflowTourLink = {
        id: "MeasurementBasicTour",
        name: "Measurement Tour",
        description: "Set up your first measurement",
        chmlnId: "63c94b6346d3880013ee4643",
    };

    static StreamingBasicTour: IWorkflowTourLink = {
        id: "StreamingBasicTour",
        name: "Streaming Tour",
        description: "Set up your streaming measurement",
        chmlnId: "63cfde779a0e090011de72b2",
    };

    static AnalysisBasicTour: IWorkflowTourLink = {
        id: "AnalysisBasicTour",
        name: "Analysis Tour",
        description: "Set up your Far Field Analysis",
        chmlnId: "63d244e93f51340018ade7b3",
    };

    static MainMenuTour: IWorkflowTourLink = {
        id: "MainMenuTour",
        name: "Main Menu Tour",
        description: "Set up your Main Menu",
        chmlnId: "63c7d3231b52a1001b3924a8",
    };

    static ManageTour: IWorkflowTourLink = {
        id: "ManageTour",
        name: "Manage Tour",
        description: "Learn all about the Manage workflow",
        chmlnId: "642ae0a4381a820018b4b764",
    };
}
